var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{attrs:{"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }